import { Injectable } from '@angular/core';
/**
 * LyTemplate

\@export
\@class LyTemplate
 */
var LyTemplate = (function () {
    function LyTemplate() {
    }
    /**
     * @param {?} viewContainercRef
     * @return {?}
     */
    LyTemplate.prototype.setTemplate = function (viewContainercRef) {
        // let tRef: any = this.viewContainerRef.createEmbeddedView(this.templateRef);
        this.___templateRef = viewContainercRef;
        return this.___templateRef;
    };
    /**
     * @param {?} refx
     * @return {?}
     */
    LyTemplate.prototype.nodes = function (refx) {
        var /** @type {?} */ ref = refx;
        var /** @type {?} */ template = document.createElement('l-y-t-e-m-p-l-a-t-e');
        ref.rootNodes.forEach(function (root) {
            template.appendChild(root);
        });
        return template;
    };
    return LyTemplate;
}());
export { LyTemplate };
LyTemplate.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
LyTemplate.ctorParameters = function () { return []; };
function LyTemplate_tsickle_Closure_declarations() {
    /** @type {?} */
    LyTemplate.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyTemplate.ctorParameters;
    /** @type {?} */
    LyTemplate.prototype._container;
    /** @type {?} */
    LyTemplate.prototype.___templateRef;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/core/ly/ly-template.js
// module id = 1354
// module chunks = 31